import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDeRemitente() {
  return (
    <ClipperPlaceholder title="Cambio de Remitente" category="Novedades" />
  );
}
